import * as Sentry from "@sentry/react";

interface Props {
	category: "login" | "button.click" | "input.change" | "click" | "keydown";
	message: string;
}

export default function ({ category, message }: Props) {
	return Sentry.addBreadcrumb({
		category,
		message,
	});
}
